export default "__VITE_ASSET__S$9ONSFW__"